/**
 * `Object.entries` and `Object.keys` widen keys to `string`, which loses the
 * key union of a literal object. These keep it.
 *
 * Only use them on objects whose type lists every key, such as an `as const`
 * literal or a `Record` built in the same module. A value typed as an
 * interface can carry extra properties at runtime, and the key type would not
 * mention them.
 */
export function objectEntries<T extends object>(
  value: T,
): [keyof T & string, T[keyof T & string]][] {
  // biome-ignore lint/plugin: keeping the key union is the entire purpose of this helper, and the widening happens inside Object.entries.
  return Object.entries(value) as [keyof T & string, T[keyof T & string]][];
}

export function objectKeys<T extends object>(value: T): (keyof T & string)[] {
  // biome-ignore lint/plugin: see objectEntries.
  return Object.keys(value) as (keyof T & string)[];
}
